import { loadSessionStateForExtraProducts } from '../../../common/utils/postBookingProductsUtils';
export const getSelectedCheckInBagOptions = () => {
  var _selectedProducts$che;
  const selectedProducts = loadSessionStateForExtraProducts();
  return (selectedProducts === null || selectedProducts === void 0 || (_selectedProducts$che = selectedProducts.checkInBaggage) === null || _selectedProducts$che === void 0 ? void 0 : _selectedProducts$che.value) || [];
};
export const isSingleChoiceForCheckInBaggagePostbookingSelected = () => {
  var _selectedProducts$che2;
  const selectedProducts = loadSessionStateForExtraProducts();
  const baggageValue = selectedProducts === null || selectedProducts === void 0 || (_selectedProducts$che2 = selectedProducts.checkInBaggage) === null || _selectedProducts$che2 === void 0 ? void 0 : _selectedProducts$che2.value;
  if (baggageValue) {
    return (baggageValue.length > 0).toString();
  }
  return undefined;
};
export const getSelectedCabinBagOptions = () => {
  var _selectedProducts$cab;
  const selectedProducts = loadSessionStateForExtraProducts();
  return (selectedProducts === null || selectedProducts === void 0 || (_selectedProducts$cab = selectedProducts.cabinBaggage) === null || _selectedProducts$cab === void 0 ? void 0 : _selectedProducts$cab.value) || [];
};
export const isSingleChoiceForCabinBaggagePostbookingSelected = () => {
  var _selectedProducts$cab2;
  const selectedProducts = loadSessionStateForExtraProducts();
  const baggageValue = selectedProducts === null || selectedProducts === void 0 || (_selectedProducts$cab2 = selectedProducts.cabinBaggage) === null || _selectedProducts$cab2 === void 0 ? void 0 : _selectedProducts$cab2.value;
  if (baggageValue) {
    return (baggageValue.length > 0).toString();
  }
  return undefined;
};
//# sourceMappingURL=getSessionDataForExtraProducts.js.map